import clsx from "clsx";

import { SubmissionModel } from "@interfaces/index";
import { formatAmount } from "@utils/index";
import { SubmissionStatus } from "@components/index";

export const TableTdDesktopSubmission = ({
  submission,
  puEnabled,
  disabled,
  onClickRow,
}: {
  submission: SubmissionModel;
  puEnabled: boolean;
  disabled?: boolean;
  onClickRow: () => void;
}) => (
  <tr
    className={clsx(
      "group border-b border-b-black-8 last:border-b-0",
      !disabled
        ? "cursor-pointer hover:bg-black-4"
        : "cursor-default bg-black-8 opacity-40",
    )}
    data-testid="tr_submissionsTable"
    onClick={() => !disabled && onClickRow()}
  >
    <td className="py-3 capitalize text-black-100">
      {submission.period.title}
    </td>
    <td className="py-3 text-black-100">{submission.userBusiness.name}</td>
    <td className="py-3 text-button">
      <SubmissionStatus status={submission.status} />
    </td>
    <td className="py-3 text-black-54">
      <div
        className="w-24 truncate pr-4 lg:w-52 xl:w-80 xxl:w-96"
        title={submission.comment}
      >
        {submission.comment}
      </div>
    </td>
    <td className="py-3 pr-6 text-right font-bold text-green-100">
      {formatAmount(submission.income)}
    </td>
    <td className="py-3 pr-6 text-right font-bold text-black-100">
      {formatAmount(submission.business)}
    </td>
    {puEnabled && (
      <td className="py-3 pr-6 text-right font-bold text-black-100">
        {formatAmount(submission.private)}
      </td>
    )}
    <td
      className={clsx(
        "py-3 pr-6 text-right font-bold",
        submission.profit[0] === "-" ? "text-black-100" : "text-green-100",
      )}
    >
      {formatAmount(submission.profit)}
    </td>
  </tr>
);
